import { Checkbox } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../../types';
import { useVedValidation } from '../useVedValidation';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

export const ApenPeis = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateVedSelection } = useVedValidation();
  const { t } = useTranslation();

  const apenPeisSelected = watch('ved.value.apenPeis.selected');

  return (
    <StyledCard isActive={apenPeisSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors?.ved?.value?.apenPeis?.selected}
          label={t('form.oppvarming.ved.apenPeis.label')}
          {...register('ved.value.apenPeis.selected', {
            validate: validateVedSelection,
            deps: ['ved.value.lukketOvn.selected', 'ved.value.peisMedDor.selected'],
            shouldUnregister: true
          })}
        />
        {apenPeisSelected && <InstallasjonsArRadio
          name={`ved.value.apenPeis.value`}
          translationKeyPrefix={`form.oppvarming.ved.apenPeis.installasjonsAr`}
        />}
      </CardContentWrapper>
    </StyledCard>
  );
};
